// extracted by mini-css-extract-plugin
export default {"boxWrapper":"Whiskerplot_boxWrapper__MizHa","text":"Whiskerplot_text__J-NX8"};